module.exports = __webpack_public_path__ + "img/NewsArticle.084992ea.jpg";